module.exports = "/assets/ecf7a8f068bf2a78043bacea596bb27a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/YM.png
// module id = 3152
// module chunks = 0